import { DropdownButtonContext } from '@dixa/lib-shared-habla';
import { Channel } from 'lib-shared-types-channels';
import { memo, useContext } from 'react';
import { useMount } from 'react-use';

import { useCopilotActionRunner } from 'components/copilotActions';
import { useEditorContext } from 'utils/useEditorContext';

interface EditorCopilotDropdownMatchToStyleGuideProps {
  /** Optional so the builder can pass it through; the action is only offered
   * where the editor has a specific channel. */
  channel?: Channel;
  csid?: string;
}

/**
 * Component that represents the "match to style guide" action in the copilot
 * dropdown. It runs on mount and paints its progress in the editor, so the
 * dropdown is only a mounting host.
 */
export const EditorCopilotDropdownMatchToStyleGuide = memo(
  function EditorCopilotDropdownMatchToStyleGuide({
    channel,
    csid,
  }: EditorCopilotDropdownMatchToStyleGuideProps) {
    const dropdownContext = useContext(DropdownButtonContext);
    const { getSelectedText } = useEditorContext();
    const { run } = useCopilotActionRunner({
      context: { actions: ['improveReplyMatchStyleGuide'] },
      text: '',
      channel,
      csid,
      // Closing the dropdown unmounts this component while the request is still
      // in flight, so it must not be cancelled.
      abortOnUnmount: false,
    });

    useMount(() => {
      if (!getSelectedText()) {
        return;
      }

      dropdownContext.closeDropdown();
      run('improveReplyMatchStyleGuide');
    });

    return null;
  },
);
